import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Truck, CheckCircle, Package, Calendar, Home as HomeIcon } from 'lucide-react';
const Home = () => {
  return <div className="w-full bg-white" data-id="element-140">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-500 to-teal-500 text-white py-20" data-id="element-141">
        <div className="container mx-auto px-4" data-id="element-142">
          <div className="max-w-3xl mx-auto text-center" data-id="element-143">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-144">
              Moving Made Simple Across Estonia
            </h1>
            <p className="text-xl mb-8" data-id="element-145">
              Professional, reliable, and stress-free moving services for homes
              and businesses
            </p>
            <Link to="/order" className="inline-flex items-center bg-white text-blue-600 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-146">
              Book Your Move
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-147" />
            </Link>
          </div>
        </div>
      </section>
      {/* How It Works Section */}
      <section className="py-16" id="how-it-works" data-id="element-148">
        <div className="container mx-auto px-4" data-id="element-149">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-150">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-151">
            <div className="text-center p-6 rounded-lg" data-id="element-152">
              <div className="bg-blue-100 text-blue-600 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-153">
                <Calendar className="h-8 w-8" data-id="element-154" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-155">1. Order</h3>
              <p className="text-gray-600" data-id="element-156">
                Fill out our simple booking form with your move details and
                requirements.
              </p>
            </div>
            <div className="text-center p-6 rounded-lg" data-id="element-157">
              <div className="bg-blue-100 text-blue-600 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-158">
                <CheckCircle className="h-8 w-8" data-id="element-159" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-160">2. Confirm</h3>
              <p className="text-gray-600" data-id="element-161">
                Review your quote, select payment method, and confirm your
                booking.
              </p>
            </div>
            <div className="text-center p-6 rounded-lg" data-id="element-162">
              <div className="bg-blue-100 text-blue-600 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-163">
                <Truck className="h-8 w-8" data-id="element-164" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-165">3. Move</h3>
              <p className="text-gray-600" data-id="element-166">
                Our professional team arrives on time and handles your move with
                care.
              </p>
            </div>
          </div>
          <div className="text-center mt-10" data-id="element-167">
            <Link to="/order" className="inline-flex items-center bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-168">
              Get Started
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-169" />
            </Link>
          </div>
        </div>
      </section>
      {/* Services Section */}
      <section className="bg-gray-50 py-16" id="services" data-id="element-170">
        <div className="container mx-auto px-4" data-id="element-171">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-172">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-173">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-174">
              <HomeIcon className="h-10 w-10 text-blue-600 mb-4" data-id="element-175" />
              <h3 className="text-xl font-semibold mb-3" data-id="element-176">Home Moving</h3>
              <p className="text-gray-600 mb-4" data-id="element-177">
                Complete relocation services for apartments and houses of all
                sizes.
              </p>
              <ul className="space-y-2" data-id="element-178">
                <li className="flex items-center" data-id="element-179">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-180" />
                  <span className="text-gray-600" data-id="element-181">
                    Furniture disassembly & reassembly
                  </span>
                </li>
                <li className="flex items-center" data-id="element-182">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-183" />
                  <span className="text-gray-600" data-id="element-184">
                    Careful handling of fragile items
                  </span>
                </li>
                <li className="flex items-center" data-id="element-185">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-186" />
                  <span className="text-gray-600" data-id="element-187">
                    Floor & furniture protection
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-188">
              <Package className="h-10 w-10 text-blue-600 mb-4" data-id="element-189" />
              <h3 className="text-xl font-semibold mb-3" data-id="element-190">Packing Services</h3>
              <p className="text-gray-600 mb-4" data-id="element-191">
                Professional packing to ensure your belongings arrive safely.
              </p>
              <ul className="space-y-2" data-id="element-192">
                <li className="flex items-center" data-id="element-193">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-194" />
                  <span className="text-gray-600" data-id="element-195">
                    Quality packing materials
                  </span>
                </li>
                <li className="flex items-center" data-id="element-196">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-197" />
                  <span className="text-gray-600" data-id="element-198">
                    Efficient packing techniques
                  </span>
                </li>
                <li className="flex items-center" data-id="element-199">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-200" />
                  <span className="text-gray-600" data-id="element-201">
                    Labeling for easy unpacking
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-202">
              <Truck className="h-10 w-10 text-blue-600 mb-4" data-id="element-203" />
              <h3 className="text-xl font-semibold mb-3" data-id="element-204">Special Items</h3>
              <p className="text-gray-600 mb-4" data-id="element-205">
                Expert handling of large, valuable, or delicate items.
              </p>
              <ul className="space-y-2" data-id="element-206">
                <li className="flex items-center" data-id="element-207">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-208" />
                  <span className="text-gray-600" data-id="element-209">Piano & artwork moving</span>
                </li>
                <li className="flex items-center" data-id="element-210">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-211" />
                  <span className="text-gray-600" data-id="element-212">Appliance installation</span>
                </li>
                <li className="flex items-center" data-id="element-213">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" data-id="element-214" />
                  <span className="text-gray-600" data-id="element-215">
                    Custom crating solutions
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16" data-id="element-216">
        <div className="container mx-auto px-4" data-id="element-217">
          <div className="bg-blue-600 text-white rounded-xl p-8 md:p-12 text-center" data-id="element-218">
            <h2 className="text-3xl font-bold mb-4" data-id="element-219">
              Ready to Start Your Move?
            </h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-220">
              Get an instant quote and book your moving service today. We're
              ready to help you move anywhere in Estonia.
            </p>
            <Link to="/order" className="inline-flex items-center bg-white text-blue-600 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-221">
              Book Your Move
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-222" />
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;